<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<form id="assemble_form" [formGroup]="forms.assemble" (submit)="onAssembleSubmit($event)" novalidate>
  <input type="hidden" name="job_id" id="job_id" formControlName="job_id">
  <input type="hidden" name="contig" id="contig_name" formControlName="contig">
  <input type="hidden" name="direction" id="direction" formControlName="direction">
  <input type="hidden" name="cutid" id="cutid" formControlName="cutid">
</form>
<form id="alignment_form" [formGroup]="forms.alignment" (submit)="onAlignmentSubmit($event)" novalidate>
  <input type="hidden" name="job_id" id="job_id_al" formControlName="job_id">
  <input type="hidden" name="db" id="db_al" formControlName="db">
  <input type="hidden" name="pb" id="bp_al" formControlName="bp">
  <input type="hidden" name="range" id="range_al" formControlName="range">
  <input type="hidden" name="chromosomename" id="chromosomename_al" formControlName="chromosomename">
  <input type="hidden" name="alignmentscale" id="alignmentscale_al" formControlName="alignmentscale">
  <input type="hidden" name="annotation_file" id="annotation_file" formControlName="annotation_file">
  <input type="hidden" name="contig" id="contig_al" formControlName="contig">
</form>
<div id="header">
  <div id="head_left">
    <div *ngIf="params$ | async as params">
      <span>[ </span>
      <span i18n>Analysis ID</span>
      <span>:{{ displayAnalysisId }} ]</span>&nbsp;
      <span>[ </span>
      <a [href]="summarylink" target="_blank" rel="noopener">{{ displaySampleName }}</a>
      <span> ]</span>&nbsp;
      <span *ngIf="params.chromosomeName">{{ params.chromosomeName }}</span>&nbsp;
      <span *ngIf="params.contig">[<span i18n>multihits</span>:{{ params.contig }}]</span>
      <br>
      <label>
        <input
          id="showmaplist"
          name="showmaplist"
          type="checkbox"
          checked
          (change)="onMaplistToggleClick($event)"
        >
        <span i18n>Show Map List</span>
      </label>
      <span> / </span>
      <label>
        <input id="embedded" name="embedded" type="checkbox">
        <span title="SV which is included in the other larger SV" i18n>Show Embedded</span>
      </label>
      <span> / </span>
      <label>
        <input id="consistent" name="consistent" type="checkbox" checked>
        <span title="Contig which has sufficient alignment quality" i18n>Show Consistent</span>
      </label>
      <span> / </span>
      <label>
        <input id="inconsistent" name="inconsistent" type="checkbox">
        <span title="Contig which has insufficient alignment quality" i18n>Show Inconsistent</span>
      </label>
      <br>
      <label>
        <input id="smallAlignment" name="smallAlignment" type="checkbox">
        <span>Hide Small Alignments less than </span>
        <div id="threshold">0.</div>
      </label>
      <span class="sliderlabel">0</span>
      <input
        id="slider"
        type="range"
        [min]="0"
        [max]="200"
        [step]="1"
        [value]="0"
        (change)="onSliderChange($event)"
      >
      <span class="sliderlabel">200</span>
    </div>
    <div id="svfilterButton">
      <button
        mat-stroked-button
        [matBadge]="badge.value"
        [matBadgeHidden]="badge.hidden"
        (click)="onFilterClick()"
      >
        <span i18n>Filter</span>
      </button>
    </div>
  </div>
  <div id="head_right">
    <button id="zoom_out" mat-icon-button>
      <mat-icon class="icon-hover material-icons-outlined material-symbols-outlined">zoom_out</mat-icon>
    </button>
    <button id="zoom_fix" mat-icon-button>
      <mat-icon class="icon-hover material-icons-outlined material-symbols-outlined">zoom_out_map</mat-icon>
    </button>
    <button id="zoom_in" mat-icon-button>
      <mat-icon class="icon-hover material-icons-outlined material-symbols-outlined">zoom_in</mat-icon>
    </button>
    <div>
      <label for="posset" i18n>Jump to</label>
      <input type="text" id="posset" autocomplete="off">
      <span>mbp</span>
    </div>
  </div>
</div>
<div id="middle">
  <div id="maplist-container" [class.collapsed]="isMaplistContainerHidden">
    <div id="maplist-header">
      <button id="toggle-maplist" mat-icon-button (click)="onMaplistContainerToggleClick()">
        <mat-icon class="icon-hover material-icons-outlined material-symbols-outlined">
          {{ isMaplistContainerHidden ? 'chevron_right' : 'close' }}
        </mat-icon>
      </button>
      <span id="maplist-header-settings">Settings</span>
    </div>
    <div id="maplist" [hidden]="isMaplistHidden">
      <div i18n>Map Contig Display</div>
      <hr>
      <div id="maps"></div>
    </div>
  </div>
  <div id="main">
    <div #canvasHost></div>
    <div id="contextMenuContig" class="context-menu">
      <div class="context-menu menu-item" id="openMultihits">Open multi-hits viewer (Click)</div>
      <div class="context-menu menu-item" id="hideOtherMaps">Hide Other Maps</div>
      <div class="context-menu menu-item" id="hideSelectedMaps">Hide Selected Maps</div>
      <div class="context-menu menu-item" id="showDepth">Show/Hide depth ({{ isMac ? 'Command' : 'Ctrl' }}+Click)</div>
      <div class="context-menu menu-item" id="showMolecules">Show/Hide Molecules</div>
      <div class="context-menu-sub" id="drawMoleculesMode">
        <div class="context-menu menu-item" id="drawMoleculesNormal">Normal mode</div>
        <div class="context-menu menu-item" id="drawMoleculesStacked">Stacked mode</div>
      </div>
      <div class="context-menu menu-item" id="openAssemble">Open Assembly Viewer (Shift+Click)</div>
      <div class="context-menu menu-item" id="reverseMap">Reverse Map (Alt+Click)</div>
    </div>
    <div id="contextMenuRefs" class="context-menu">
      <div class="context-menu menu-header">Show / Hide Track</div>
      <div class="context-menu menu-item" id="gbandToggle">G-Band</div>
      <div class="context-menu menu-item" id="refgeneToggle">Ref Gene</div>
      <div class="context-menu menu-item" id="svToggle">SV</div>
    </div>
    <div id="contextMenuAlignments" class="context-menu">
      <div class="context-menu menu-item" id="alignContigs">Align Contigs</div>
    </div>
  </div>
</div>
<div class="pURL">
  <span id="copyLink" (click)="onCopyLinkClick($event)" i18n>Click to copy shareable link</span>
  <div id="copyBalloon" i18n>Copied!</div>
</div>
<div id="footer"></div>
